import { Box } from '@chakra-ui/react'
import type { FC } from 'react'

import CopilotLogo from './assets/Agent Co-pilot background.svg'

const Background: FC = () => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      position="absolute"
      height="300px"
      width="100%"
      aria-hidden
      bottom={0}
      zIndex={-1}
      overflow="hidden"
    >
      <CopilotLogo width="100%" />
    </Box>
  )
}

export default Background
